import getSurfaceStore from '../store/store';
import { mutatorAction } from 'satcheljs';

/**
 * Changes request id in surface store
 */
const updateRequestId = mutatorAction('updateRequestId', () => {
    getSurfaceStore().requestId = getSurfaceStore().requestId + 1;
});

export default updateRequestId;
